import React from 'react';
import { Container, Row, Col, Button, Card, Navbar, Nav } from 'react-bootstrap';
import HeaderCarousel from '../../components/landing/Carrousel';
import Testimonial from '../../components/landing/Testimonial';
import Specialist from '../../components/landing/Specialist';
import RecipeAndAdvice from '../../components/landing/RecipeAndAdvice';
import Header from '../../layouts/nav/Header';
import HeaderLanding from '../../components/landing/Header';
import FooterPage from '../../components/landing/Footer';
import alimtProg from "../../../images/conseiller-nutrition.jpg";
import fitnessProg from "../../../images/gallery/pic8.webp";
import suiviProg from "../../../images/gallery/pic9.jpg";
import { useTranslation } from 'react-i18next';

const LandingPage = () => {
  const { t } = useTranslation();

  return (
    <>
   
    
      <HeaderLanding />
      <HeaderCarousel />

      <section id="features" className="py-5">
        <Container>
          
          <h2
            className="text-center mb-5"
            style={{
              backgroundColor: "#90EE90",
              color: "#fff",
              border: "1px solid #CECECE",
              paddingTop: "35px",
              paddingBottom: "25px",
              width: "100vw",
              marginLeft: "calc(-50vw + 50%)",
            }}
          >
            {t("landing.features.title")}
          </h2>
          <Row>
            <Col md={4}>
              <Card className="mb-4 card-hover">
                <Card.Img
                  variant="top"
                  src={fitnessProg}
                  alt="Fitness"
                  className="image-recipe"
                />
                <Card.Body>
                  <Card.Title>{t("landing.features.fitness.title")}</Card.Title>
                  <br />
                  <Card.Text>{t("landing.features.fitness.desc")}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mb-4 card-hover">
                <Card.Img
                  variant="top"
                  src={alimtProg}
                  alt="Programme alimentaire"
                  className="image-recipe"
                />
                <Card.Body>
                  <Card.Title>{t("landing.features.diet.title")}</Card.Title>
                  <br />
                  <Card.Text>{t("landing.features.diet.desc")}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="mb-4 card-hover">
                <Card.Img
                  variant="top"
                  src={suiviProg}
                  alt="Suivi"
                  className="image-recipe"
                  style={{ height: "206px" }}
                />
                <Card.Body>
                  <Card.Title>{t("landing.features.tracking.title")}</Card.Title>
                  <br />
                  <Card.Text>{t("landing.features.tracking.desc")}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <Specialist />
      <RecipeAndAdvice />
      <Testimonial />

      <section id="pricing" className="bg-light py-5">
        <Container>
          <h2 className="text-center mb-5">{t("landing.pricing.title")}</h2>
          <Row>
            {["basic", "premium", "pro"].map((planKey, index) => {
              const features = t(`landing.pricing.${planKey}.features`, {
                returnObjects: true,
              });

              return (
                <Col md={4} key={index}>
                  <Card
                    className={planKey === "premium" ? "border-primary" : ""}
                  >
                    <Card.Header
                      as="h5"
                      className={planKey === "premium" ? "bg-primary text-white" : ""}
                    >
                      {t(`landing.pricing.${planKey}.name`)}
                    </Card.Header>
                    <Card.Body>
                      <Card.Title>
                        {t(`landing.pricing.${planKey}.price`)}
                      </Card.Title>
                      <ul>
                        {Array.isArray(features) &&
                          features.map((feature, idx) => (
                            <li key={idx}>{feature}</li>
                          ))}
                      </ul>
                      <Button variant="primary">{t("landing.pricing.choose")}</Button>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>

      <section id="contact" className="py-5">
        <Container>
          <h2 className="text-center mb-5">{t("landing.contact.title")}</h2>
          <Row>
            <Col md={6} className="mx-auto">
              <form>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    {t("landing.contact.name")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    {t("landing.contact.email")}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    {t("landing.contact.message")}
                  </label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="3"
                    required
                  ></textarea>
                </div>
                <Button variant="primary" type="submit">
                  {t("landing.contact.send")}
                </Button>
              </form>
            </Col>
          </Row>
        </Container>
      </section>

      <footer>
        <FooterPage />
        <p className="bg-dark text-white text-center py-3">
          {t("landing.footer")}
        </p>
      </footer>
    </>
  );
};

export default LandingPage;